/* eslint-disable */



import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./stores";
import "normalize.css";
import "lib-flexible/flexible.js";
import "babel-polyfill";
import "./assets/icon/style.css";
import "./assets/sass/app.scss";
import FastClick from "fastclick";
import moment from "moment";
import WechatPlugin from "@/plugins/wechat";
import pkg from "../package.json";

import {
DatetimePicker,
Popup,
Picker,
Switch,
Overlay,
Stepper,
PasswordInput,
Dialog,
SwipeCell,
CheckboxGroup,
Checkbox,
Uploader,
RadioGroup,
Radio,
List,
PullRefresh,
Cell,
Sticky,
} from "vant";
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Switch);
Vue.use(Overlay);
Vue.use(Stepper);
Vue.use(PasswordInput);
Vue.use(Dialog);
Vue.use(SwipeCell);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Uploader);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Cell);
Vue.use(Sticky);

const whiteUrls = [
'todayOilPrice',
'noScrectPaymentAgreement',
'/enterprise',
'/vipIntro',
'/points',
'/registration'
]

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import {
getCookie,
rap,
fetch,
getHashParms,
isDuringDate,
getParamValueFromUrl,
removeSpecificParam,
} from "@/utils/common";
/* 优化移动端点击300ms延迟 插件 */
const str = navigator.userAgent.toLowerCase();
const ver = str.match(/cpu iphone os (.*?) like mac os/);
if (!ver) {


FastClick.attach(document.body);
} else {
console.log("你当前的Ios系统版本为：" + ver[1].replace(/_/g, "."));
if (parseInt(ver[1]) >= 11) {

} else {

FastClick.attach(document.body);
}
}












Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);
Vue.use(WechatPlugin); 
Vue.use(DatetimePlugin);
Vue.use(LoadingPlugin);
Vue.use(require("vue-wechat-title")); 
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];

let pathname = "";

let selfCompanyId = "";
if (location.hash.match(/\d+/)) {
pathname = location.hash.match(/\d+/)[0];
Vue.prototype._compneyId_ = location.hash.match(/\d+/)[0];
selfCompanyId = location.hash.match(/\d+/)[0];
localStorage.setItem("compneyId", selfCompanyId);
}





console.log("VERSION:", pkg.version);


const customList = ["4404027"];
const _isCustom_ = customList.includes(pathname);
Vue.prototype._isCustom_ = customList.includes(pathname); 



let _partnerStateMemCache = null;      
let _partnerStatePromise = null;       
/**
* 获取合作伙伴模式状态
* - 先读内存缓存 -> 兜底调接口（只在首次进入应用调用一次）
* - 刷新页面 / 关闭公众号 / 退出 webview：JS内存清空 -> 下次进来自动重新请求接口
* @returns {Promise<boolean>} partnerState
*/
async function getPartnerState() {

if (_partnerStateMemCache !== null) {
return _partnerStateMemCache;
}

if (_partnerStatePromise) {
return _partnerStatePromise;
}
const urlPartner = rap({
sign: `/fep/wx/${pathname}/payment/getPartnerState`,
});
_partnerStatePromise = (async () => {
try {
const res = await fetch(urlPartner.sign, {});
const state = !!(res && res.data && res.data.partnerState);
_partnerStateMemCache = state;
return state;
} catch (e) {

_partnerStateMemCache = true;
return true;
} finally {

_partnerStatePromise = null;
}
})();
return _partnerStatePromise;
}

function directRightUrl() {
let paths = window.location.href.split("#");
paths[1] = paths[1] || "/";

if (paths[0].charAt(paths[0].length - 1) !== "?") {





paths[0] = `${paths[0]}?`;
}
let url = `${paths[0]}#${paths[1]}`;
if (window.location.href !== url) {
window.location.href = url;
}
}


Vue.filter("ftime", function (value) {
if (!value) return "";
value = moment(value).format("YYYY-MM");
return value;
});


import Navigation from "vue-navigation";
Vue.use(Navigation, { router });


directRightUrl();
router.beforeEach((to, from, next) => {

if (to.matched.length === 0) {
next({
path: `/notfound/${selfCompanyId}?str=${encodeURIComponent(to.path)}`,
});

return;
}

if (to.fullPath.indexOf("/pay/") > -1) {
let newPath = to.fullPath;
if (_isCustom_) {
newPath = newPath.replace("/pay/", "/payJiahua/");
} else {
newPath = newPath.replace("/pay/", "/payNp/");
}
next({ path: newPath });
return;
}

for (var i=0; i<whiteUrls.length; i++) {
const url = whiteUrls[i]
if (to.path.indexOf(url) > -1) {
next();
return;
}
}


if (to.path.indexOf("loginByUnionId") > -1) {
next();
return;
}
/**
* sdkConfig 常规功能sdk 为了配置字体大小不缩放，所有非支付部分路由全部加上这个配置
* mallSdk 支付部分sdk
*/

function nextLoginByUnionId(next) {

let url = rap({
login: `/fep/wx/${pathname}/member/loginByUnionId`,
});


const unionId = getParamValueFromUrl(location.href, "uid");

let href = removeSpecificParam(location.href, "uid");
if (!unionId) {
alert("异常(uid null)");
return;
}

fetch(url.login, {
unionId: unionId,
})
.then((res) => {


next();

})
.catch((err) => {
alert(err.message || "异常");
});
}


const isMiniApp = navigator.userAgent.indexOf("miniProgram") > -1;

if (isMiniApp) {
const lat = getParamValueFromUrl(location.href, "lat");
const lng = getParamValueFromUrl(location.href, "lng");

if (lat && lng) {
localStorage.setItem("latitude", lat);
localStorage.setItem("longitude", lng);
}

}

const cookieName = `${pathname}_openid`;
const isPower = !!getCookie(cookieName);
const searchPath = location.hash.split("?")[1];
const search = searchPath ? `%3F${encodeURIComponent(searchPath)}` : "";
const resolveUrl = `/%3F%23${to.path}${search}`;

if (!isPower && to.path !== "/") {

if (isMiniApp) {

nextLoginByUnionId(next);
} else {

let shareId = getHashParms().shareId || "";
console.log(shareId);
const toUrl = `/fep/weixinopen/toAuthorizeUrl/${pathname}?pageUri=${resolveUrl}&shareId=${shareId}`;
window.location.href = toUrl;
}
} else if (isPower && to.path !== "/") {
const openid = !!getCookie("weixin_openid");
const shouldToAuthorizeUrl = to.meta.shouldToAuthorizeUrl;
if (!openid && shouldToAuthorizeUrl) {
if (isMiniApp) {



next();

return;
} else {

const mallUrl = encodeURIComponent(
location.href.replace(`${location.protocol}//${location.host}`, "")
).replace(/\%2F/g, "/");
const toUrl = `/fep/weixin/toAuthorizeUrl?pageUri=${mallUrl}`;
window.location.href = toUrl;
}
} else {
next();
Vue.nextTick(async () => {

let check = false;

const partnerState = await getPartnerState();

if (!partnerState) {

check = true;
}

if (to.meta.sdkConfig || (check && to.meta.mallSdk)) {

let url = rap({
sign: `/fep/weixinopen/getJsSdkConfig/${pathname}`,
});
const hashPath = location.href.replace(
`${location.protocol}//${location.host}`,
""
);


fetch(url.sign, {
pageUri: hashPath,
}).then((res) => {
console.log("url.sign", res, hashPath);
Vue.wechat.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
beta: true,
appId: res.data.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.noncestr, // 必填，生成签名的随机串
signature: res.data.sign, // 必填，签名，见附录1
jsApiList: [
"getLocation",
"openLocation",
"onMenuShareTimeline",
"onMenuShareAppMessage",
"chooseImage",
"previewImage",
"uploadImage",
"scanQRCode",
"chooseWXPay",
"chooseInvoiceTitle",
], // 必填，需要使用的JS接口列表
openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放
});

});
} else if (to.meta.mallSdk) {

let url = rap({

getJsSdkConfig: `/fep/weixin/getJsSdkConfig`,
});
const hashPath = location.href.replace(
`${location.protocol}//${location.host}`,
""
);


fetch(url.getJsSdkConfig, {
pageUri: hashPath,
}).then((res) => {
Vue.wechat.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.noncestr, // 必填，生成签名的随机串
signature: res.data.sign, // 必填，签名，见附录1
jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放
});

});
} else {


}
});
}
}
});
/* eslint-disable no-new */
new Vue({
el: "#app",
router,
store,
components: {
App,
},
template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js